import {Component} from "@angular/core";
import {Notification} from "./notification";

@Component({
    selector: 'db-notifier',
    templateUrl: './notifier.component.html',
    styleUrls: ['./notifier.component.scss'],
    standalone: false
})
export class NotifierComponent {

  private static NOTIFICATION_DURATION: number = 5000;

  public static notifications: Notification[] = [];

  constructor() {}

  public static notify(notification: Notification): void {
    NotifierComponent.notifications.push(notification);
    notification.add();

    if (!notification.persist) {
      setTimeout(() => {
        NotifierComponent.removeNotification(notification);
      }, NotifierComponent.NOTIFICATION_DURATION);
    }
  }

  private static removeNotification(notification): void {
    notification.remove();

    setTimeout(() => {
      NotifierComponent.notifications.splice(NotifierComponent.notifications.indexOf(notification), 1);
    }, 250); // notification animation duration
  }

  public get notifications(): Notification[] {
    return NotifierComponent.notifications;
  }

  public removeNotification: Function = NotifierComponent.removeNotification;

}
